const LoginUser = (response: any) => {
    return {
        type: 'LOGIN',
        payload: response,
    }
}

const LogoutUser = () => {
    return { type: 'LOGOUT' }
}

export { LoginUser, LogoutUser };